import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import {
  ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { TagType, TagGroupInfoFragment } from 'generated/graphql';

@Component({
  selector: 'app-field-search-select',
  templateUrl: './field-search-select.component.html',
})
export class FieldSearchSelectComponent extends WithDisposableSubject() {

  // <Overlay Related>
  /** Is the dropdown open? */
  isOpen = false;

  @Input() cdkConnectedOverlayOffsetY: number;

  /**
   * Optional label text
   */
  @Input() label: string;

  /**
   * Indicates if the select should have a
   * clear icon to reset the selection. Default is true
   */
  @Input() clearable = true;

  /**
   *  Reference to trigger to open the select
   *  (Used to dynamically set initial width)
   */
  @ViewChild(CdkOverlayOrigin) trigger: CdkOverlayOrigin;
  @ViewChild(CdkConnectedOverlay) overlay: CdkConnectedOverlay;

  /**
   *  Use observable to get the trigger width to avoid a
   *  ExpressionChangedAfterItHasBeenCheckedError
   */
  private _triggerWidth = new Subject<string>();

  /**
   *  Use observable to get the trigger width to avoid a
   *  ExpressionChangedAfterItHasBeenCheckedError
   */
  triggerWidth$ = this._triggerWidth.asObservable().pipe(
    takeUntil(this.disposer)
  );

  // </Overlay Related>
  /**
   * TODO: Not fully implemented
   */
  @Input() multiple: boolean;

  /**
   * Hides readonly categories
   * for Role less than Lead.
   */
  @Input() hideReadonly: boolean;

  @Input() hideUniversal: boolean;

  @Input() targetType: 'EntityType' | 'EntityConnectionType';

  /** Only displays fields for given EntityTypeId or EntityConnectionTypeId
   *  targetType input must be set to EntityType or EntityConnctionType;
   */
  @Input() targetTypeId: string;

  /**
   *  Only display when in the following campaign
   *  Required if withTypeSelect is true
   */
  @Input() campaignId: string;

  /**
   * Limit fields to only these tag types
   */
   @Input() tagTypes: Array<TagType>;

  /**
   * Class(es) to add to the trigger
   */
  @Input() triggerClass: string;

  /**
   * Class(es) to add to the dropdown depending on context
   */
  @Input() dropdownClass: string;

  /**
   * Currently selected field
   */
  @Input() selectedField: { id: string; name: string };

  /**
   * Emits when field is changed
   */
  @Output() selectedFieldChange = new EventEmitter<any>();

  /**
   * Includes inline filter to only return fields
   * for a specific entity or connection type.
   * A campaignId is required along with targetType
   */
  @Input() withTypeSelect: boolean;

  /** Optional filter function to filter available options */
  @Input() filterOptionsFn: (groups: TagGroupInfoFragment[]) => TagGroupInfoFragment[];


  /**
   *
   */
  constructor(
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  /** Category has been selected */
  onItemSelected(event: any) {
    this.selectedFieldChange.emit(event);
    this.closeOverlay();
  }

  openOverlay() {
    const width = this.trigger?.elementRef?.nativeElement?.offsetWidth;
    this._triggerWidth.next(width ? `${width}px` : '100%');
    this.isOpen = true;
    this._cd.markForCheck();
  }

  closeOverlay() {
    this.isOpen = false;
    this._cd.markForCheck();
  }
}
